import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import colors from '../../theme/Colors';
import { jsonParser } from '../../utils/JsonUtility';
import RemoteConfig from '../../utils/RemoteConfig';
import { REMOTE_CONFIG_KEYS } from '../../config/Constants';

const TabAppCues = () => {
  const data = jsonParser(RemoteConfig.getValue(REMOTE_CONFIG_KEYS.tab_app_cue)) || {};
  const { title = '', showAppCue = false, color = '' } = data;
  if (!showAppCue) return null;
  const containerStyle = [style.tooltipContainer, { color }];
  return (
    <View>
      <TouchableOpacity style={containerStyle}>
        <Text style={style.tooltipText}>{title}</Text>
        <View style={style.tooltipArrow} />
      </TouchableOpacity>
    </View>
  );
};

export default TabAppCues;

const style = StyleSheet.create({
  tooltipContainer: {
    position: 'absolute',
    right: 0,
    top: -50,
    backgroundColor: colors.white_background,
    width: 130,
    height: 22,
    borderRadius: 10,
  },
  tooltipText: {
    position: 'absolute',
    fontSize: 10,
    fontFamily: 'Roboto-Bold',
    color: colors.foxyBlack,
    paddingHorizontal: 2,
    paddingTop: 2,
    alignSelf: 'center',
  },
  tooltipCrossContainer: {
    position: 'absolute',
    top: -70,
    right: 0,
    backgroundColor: colors.white_background,
    borderRadius: 9,
    height: 18,
    width: 18,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible',
  },
  tooltipArrow: {
    position: 'absolute',
    bottom: -6, // Adjust to place arrow below the tooltip
    left: '80%',
    transform: [{ translateX: -5 }, { rotate: '45deg' }],
    width: 10,
    height: 12,
    backgroundColor: colors.white_background,
  },
});
